import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PiggyBank } from "lucide-react";
import { api } from "@/lib/api";

const gbp = (v) => `£${Number(v || 0).toLocaleString("en-GB", { maximumFractionDigits: 0 })}`;

export const BudgetWarning = ({ testid = "budget-warning", linkTo }) => {
  const year = new Date().getFullYear();
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/trustee/budgets", { params: { year } }).then((r) => setRows(r.data.filter((b) => b.state === "warn" || b.state === "over"))).catch(() => {});
  }, [year]);
  if (!rows.length) return null;
  const over = rows.filter((r) => r.state === "over").length;
  return (
    <section data-testid={testid} className={`rounded-2xl border-2 p-4 ${over ? "border-red-500/70 bg-red-500/10" : "border-amber-500/70 bg-amber-500/10"}`}>
      <div className={`flex flex-wrap items-center gap-2 text-sm font-extrabold ${over ? "text-red-300" : "text-amber-300"}`}>
        <PiggyBank className="h-4 w-4" /> {year} repair budget: {rows.length} bike{rows.length > 1 ? "s" : ""} past 80%{over ? ` (${over} over budget)` : ""}
        {linkTo && <Link to={linkTo} onClick={(e) => { const el = document.getElementById("budgets"); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: "smooth" }); } }} data-testid={`${testid}-link`} className="ml-auto text-xs font-semibold underline">View budgets</Link>}
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {rows.map((r) => (
          <span key={r.bike_id} data-testid={`budget-warning-${r.bike_id}`}
            className={`rounded-full px-3 py-1 text-xs font-bold ${r.state === "over" ? "bg-red-600 text-white" : "bg-amber-500 text-black"}`}>
            {r.bike} · {r.pct}% · {gbp(r.spent)} of {gbp(r.budget)}
          </span>
        ))}
      </div>
    </section>
  );
};
